// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { BackupService } from './backup.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Backup } from './backup.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import { MatSelect } from '@angular/material/select';

import {
  MatDialog
} from '@angular/material/dialog';
export interface DialogData {
  interval: number;
  selectedGroups: string[];
}
@Component({
  selector: 'app-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['style.scss']
})
export class BackupComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Backup>;

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  interval
  active
  blacklist
  number

  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['number', 'active', 'interval', 'blacklist', 'actions'];

  constructor(private authenticationService: AuthenticationService, private backupService: BackupService, public dialog: MatDialog,

    private changeDetectorRefs: ChangeDetectorRef, private storageService: ApiService, private utilsService: UtilsService) { }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  // metodo utilizzato per abilitare il filtraggio nella tabella
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // la prima cosa da fare entrando nella pagina è richiamare il metodo di popolamento tabella
  ngOnInit() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile
    this.storageService.getBackup();

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.backupService.getBackup());
    this.subscription = this.backupService.backupChanged.subscribe(
      (backups: Backup[]) => {
        this.dataSource = new MatTableDataSource(backups);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

      }
    );
  }
  update() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile
    this.storageService.getBackup();

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.backupService.getBackup());
    this.subscription = this.backupService.backupChanged.subscribe(
      (backups: Backup[]) => {
        this.dataSource = new MatTableDataSource(backups);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

      }
    );
  }

  onEdit(): void {
    var me = this
    const dialogRef = this.dialog.open(EditBackup, {
      width: '550px',
      height: '550px',
      data: { interval: this.interval, number: this.number, blacklist: this.blacklist, active: this.active }
    });
    dialogRef.afterClosed().subscribe(result => {
      for (var i = 0; i <result.selectedGroups.length;i++) {
        result.selectedGroups[i] = result.selectedGroups[i].split(" - ")[0]
      }
      var edit = {
        'interval': parseInt(result.interval), 'number': result.number, 'active': result.active == "true" ? true : false,
        'blacklist': result.selectedGroups.toString()
      }
      me.storageService
        .updateBackup(edit)
        .subscribe(
          value => {
            me.update();
          }
        );
    });
  }

  addzero(element) {
    var res
    element <= 9 ? res = "0" + element : res = element
    return res
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, this.displayedColumns);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
      delete v.timestamp
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }
  download() {
    this.downloadFile(this.backupService.getBackup(), 'stato_chiamate');
  }

}
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';

import {
  Inject
} from '@angular/core';

@Component({
  selector: 'edit-backup',
  templateUrl: 'edit-backup.html',
})
export class EditBackup implements OnInit {
  groupids = []
  selectedGroups = []
  @ViewChild('matRefG', { static: false }) matRefG: MatSelect;

  constructor(
    private storageService: ApiService,
    public dialogRef: MatDialogRef<EditBackup>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  ngOnInit() {
    const me = this;
    this.storageService.getGroupsList().subscribe(v => {
      this.groupids = v
    })
  }
  changeGroup(event) {
    if (event.isUserInput) {
      if (event.source.selected) {
        this.selectedGroups.push(event.source.viewValue)
      } else {
        var index = this.selectedGroups.indexOf(event.source.viewValue);
        if (index !== -1) {
          this.selectedGroups.splice(index, 1);
        }
      }
      this.data.selectedGroups = this.selectedGroups
    }
  }
  cleargroups() {
    this.matRefG.options.forEach((data: any) => data.deselect());
    this.selectedGroups = []
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}